import { FormControlLabel, Radio, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC, ReactNode } from 'react';

const BorderedStack = styled(Stack)<{ selected: boolean }>(({ selected, theme }) => ({
  borderRadius: 4,
  padding: 8,
  borderWidth: 1,
  borderStyle: selected ? 'solid' : 'none',
  borderColor: theme.palette.primary.main,
}));

interface RadioFormProps {
  selectedValue: string;
  label: string;
  children: ReactNode;
}

export const RadioForm: FC<RadioFormProps> = ({ children, selectedValue, label }) => {
  const isSelected = selectedValue == label;
  return (
    <BorderedStack selected={isSelected}>
      <FormControlLabel value={label} control={<Radio required />} label={label} />
      {isSelected && children}
    </BorderedStack>
  );
};
